module.exports = __webpack_public_path__ + "static/media/onCall.a5546fd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/onCall.svg
// module id = 254
// module chunks = 0